import { apiCallPost } from "../api";
import { apiPaths } from "../config/apiPaths";

export const getTemplateLibraryApi = async (inputData = {}, authHeaders) => {
  try {
    const apiInputData = {
      ...inputData,
    };

    const res = await apiCallPost(apiPaths.whatsappTemplate, apiInputData, authHeaders);
    if (res) {
      return { data: res, status: true };
    }
    return { data: {}, status: false, errMsg: 'Failed to fetch template library' };
  } catch (err) {
    return { status: false, errMsg: err.message };
  }
};
